import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("aeras_admin_token", data.access_token);
      localStorage.setItem("aeras_admin_email", data.email);
      toast.success("Accesso effettuato.");
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(apiError(err) ?? "Credenziali non valide.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-white text-[#0a0a0a] flex items-center justify-center px-6" data-testid="admin-login">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-12">
          <span className="font-display text-3xl tracking-tighter">
            aér<span className="text-[#007A8A]">à</span>s
          </span>
          <span className="font-mono text-[10px] tracking-[0.3em] text-[#52525b]">
            CONSOLE
          </span>
        </div>

        <div className="font-mono text-[10px] tracking-[0.3em] text-[#007A8A] mb-4">
          — ACCESSO AREA RISERVATA
        </div>
        <h1 className="font-display text-5xl tracking-tighter leading-none mb-12">
          Console.
        </h1>

        <form onSubmit={submit} className="space-y-6" data-testid="admin-login-form">
          <div>
            <label className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#3f3f46] mb-2 block">
              Email
            </label>
            <input
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b border-[#e4e4e7] focus:border-[#007A8A] outline-none py-3 text-base font-body transition-colors"
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <label className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#3f3f46] mb-2 block">
              Password
            </label>
            <input
              required
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-b border-[#e4e4e7] focus:border-[#007A8A] outline-none py-3 text-base font-body transition-colors"
              data-testid="admin-login-password"
            />
          </div>
          <button
            type="submit"
            disabled={busy}
            className="btn-primary w-full justify-center mt-8 disabled:opacity-40"
            data-testid="admin-login-submit"
          >
            {busy ? "Accesso…" : "Accedi →"}
          </button>
        </form>

        <div className="mt-12 font-mono text-[10px] tracking-[0.2em] uppercase text-[#52525b]">
          Console riservata al personale Aéràs. Accessi tracciati.
        </div>
      </div>
    </div>
  );
}
